import LoginForm from './LoginForm'
import withLogin from './withLogin'

export default withLogin(LoginForm)
